export const formatSecondsString = (seconds: number) => {
  const hours = Math.floor(seconds / 3600).toString();
  const minutes = Math.floor((seconds % 3600) / 60).toString();
  const secs = Math.floor(seconds % 60).toString();

  if (hours !== '0') {
    return `${hours}h ${minutes}m ${secs}s`;
  }

  return `${minutes}m ${secs}s`;
};

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23'
});

// e.g. 10/08/2026, 14:05
export const formatDate = (date: Date) => {
  return `${dateFormatter.format(date)}, ${timeFormatter.format(date)}`;
};

// e.g. 10/08/2026 at 14:05
export const formatDateAtTime = (date: Date) => {
  return `${dateFormatter.format(date)} at ${timeFormatter.format(date)}`;
};

export const isMonthDateRange = (dateRange: [Date, Date]): boolean => {
  const [start, end] = dateRange;
  const diffTime = Math.abs(start.getTime() - end.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays >= 28 && diffDays <= 31;
};

// Find, convert, and replace all ISO 8601 strings and with local date strings
export const formatUtcDatesAsLocal = (str: string): string => {
  return str.replace(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z/g, (match) => formatDateAtTime(new Date(match)));
};
